import React from "react";
import Layout from "../../../../components/layout";
import ApmNavbar from "../../../../components/navbar-apm";
import FeatureMenu from "../../../../components/feature-menu";

const Page = () => (
  <Layout title="APM Features" hasSubNav={true}>
    <ApmNavbar selection="features" />

    <div className="container apm-features">
      <div className="columns">
        <FeatureMenu active="txn" />

        <div className="column feature-content">
          <div className="tab-pane active" id="transactions">
            <h3>TRANSACTIONS</h3>
            <div className="grid-container features-container transaction-gallery">
              <div className="img-wrap item-a">
                <a href="/img/apm/features/transaction1.png" rel="alternate">
                  <img src="/img/apm/features/transaction1.png" alt="" />
                </a>
              </div>
              <div className="text-wrap item-a">
                <h4>Detailed Transaction Breakdown</h4>
                <h4>
                  <span>See every layer of a Transaction, along with Throughput and Error Rate. Asynchronous Calls shown on a separate graph.</span>
                </h4>
              </div>
              <div className="img-wrap item-b">
                <a href="/img/apm/features/transaction2.png" rel="alternate">
                  <img src="/img/apm/features/transaction2.png" alt="" />
                </a>
              </div>
              <div className="text-wrap item-b">
                <h4>Relative to Average</h4>
                <h4>
                  <span>Timeline shown as relative to Average value</span>
                </h4>
              </div>
            </div>
            <div className="grid-container features-container transaction-gallery">
              <div className="img-wrap item-a">
                <a href="/img/apm/features/transaction3.png" rel="alternate">
                  <img src="/img/apm/features/transaction3.png" alt="" />
                </a>
              </div>
              <div className="text-wrap item-a">
                <h4>Per JVM Stats</h4>
                <h4>
                  <span>Stats broken down at a Per JVM level</span>
                </h4>
              </div>
              <div className="img-wrap item-b">
                <a href="/img/apm/features/transaction4.png" rel="alternate">
                  <img src="/img/apm/features/transaction4.png" alt="" />
                </a>
              </div>
              <div className="text-wrap item-b">
                <h4>Per Transaction Errors</h4>
                <h4>
                  <span>Error Rate and Exceptions thrown by every transaction</span>
                </h4>
              </div>
            </div>
            <div className="grid-container features-container transaction-gallery">
              <div className="img-wrap item-a">
                <a href="/img/apm/features/transaction5.png" rel="alternate">
                  <img src="/img/apm/features/transaction5.png" alt="" />
                </a>
              </div>
              <div className="text-wrap item-a">
                <h4>Transaction Traces</h4>
                <h4>
                  <span>At-a-glance view of Exceptions, Application Error Rate and Transactions with errors.</span>
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
);

export default Page;
